/**
 * @file コンポーネント：プライバシーポリシー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPrivacypolicy = styled.div``;

export const StyledPrivacypolicyContainer = styled.div``;

export const StyledPrivacypolicyFrame = styled.div`
    overflow-y: auto;
    max-height: 35vh;

    &[data-on-color="white"] {
        background-color: #d9d9d9;
    }
`;

export const StyledPrivacypolicyLabel = styled.label`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    text-align: center;
`;

export const StyledPrivacypolicyLabelCheckbox = styled.input`
    margin-right: 4px;
`;

export const StyledPrivacypolicyLabelText = styled.span`
    font-size: 14px;
    line-height: 18px;

    &[data-on-color="white"] {
        color: #000000;
    }
`;

export const StyledPrivacypolicyParagraph = styled.p`
    margin-bottom: 16px;
    font-size: 13px;
    line-height: 15.7px;

    &[data-on-color="white"] {
        color: #757575;
    }
`;
